import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from './loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(private loaderService: LoaderService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Check if the request URL contains 'BlobStorage' or 'Document'
    const shouldShowLoader =
      req.url.includes('BlobStorage') || req.url.includes('Document');

    if (shouldShowLoader) {
      this.loaderService.show(); // Show loader
    }

    return next.handle(req).pipe(
      finalize(() => {
        if (shouldShowLoader) {
          this.loaderService.hide(); // Hide loader when the request completes
        }
      })
    );
  }
}
